import React from 'react'
import { shape, node, bool } from 'prop-types'
import classNames from 'classnames'

import ThemeConsumer from '../ThemeConsumer'


const Box = ({
  theme,
  children,
  flexible,
  flex,
  fontInherit,
  className
}) => {
  const classes = classNames(
    theme.vertical,
    theme.box,
    { 'u-flexGrow1': flex},
    { [theme.fontInherit]: fontInherit},
    { [theme.flexible]: flexible },
    className
  )

  return (
    <section className={classes}>
      {children}
    </section>
  )
}

Box.propTypes = {
  children: node,
  flex: bool,
  flexible: bool,
  theme: shape({
  }),
}

Box.defaultProps = {
  children: null,
  flex: true,
  flexible: false,
  theme: {},
}

export default ThemeConsumer('UIBox')(Box)



// WEBPACK FOOTER //
// ./src/shared/components/Box/Box.js